<template>
  <span :title="type" :class="['micad_destinationLevelIcon',getClass(type)]"></span>
</template>

<script>
export default {
  name: 'Destination-level-icons',
  props: {
    type: String,
  },
  methods: {
   getClass(type) {
    if (type !== undefined) {
      return ' micad_destinationLevelIcon_'+type
      }
    }
  }
};
</script>